import * as React from 'react';
import { muiTruthmark } from '@ally/metronome-icons';
import { Box, get, Icon, Link, Space, TextBody } from '@ally/metronome-ui';
import styled from 'styled-components';
import { LoginHeading } from '../../../Layout/Layout';
const InsightAllyContainer = styled(Box) `
  position: relative;
  border: 1px solid ${get.colors('slate-1')};
  background: ${get.colors('white')};
  padding: 0px 2px;
  font-size: 16px;
  border-radius: 3px;
  box-shadow: 0 1px ${get.colors('slate-3')};
  font-weight: 700;
  height: 24px;
  width: 23px;

  ::after {
    border-right: 8px solid transparent;
    border-top: 8px solid #ddd;
    content: '';
    position: absolute;
  }

  ::after {
    top: 10px;
    border-color: white transparent transparent transparent;
    z-index: 10;
    left: 20px;
  }
`;
const AllyIcon = () => (React.createElement(InsightAllyContainer, null,
    React.createElement(Icon, { icon: muiTruthmark, fill: "plum", size: "md" })));
export const MFASuppressionNoOptions = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginHeading, { title: "Additional Verification Needed" }),
        React.createElement(Box, { display: "flex", alignItems: "flex-start", justifyContent: "left" },
            React.createElement(AllyIcon, null),
            React.createElement(Space, { ml: "sm" },
                React.createElement(Box, null,
                    React.createElement(Space, { mb: "sm" },
                        React.createElement(TextBody, { size: "sm", tag: "p" },
                            "We can't currently email your code, so call us at",
                            ' ',
                            React.createElement(Link, { text: "1-877-247-2559", href: "tel:18772472559" }),
                            " for help."),
                        React.createElement(TextBody, { size: "sm", tag: "p" }, "Next time you log in, consider adding your phone number to your profile so we can send your code by text message.")))))));
};
//# sourceMappingURL=MFASuppressionNoOptions.js.map